export class InstanceQueuePanelFilter {
  BusinessProcessId: number;
  StateId: number;
  UserId: number;
}
